import { inject, InjectionToken } from '@angular/core';
import { NavigationService } from '../services';

export const NAVIGATION_TOKEN: InjectionToken<NavigationProvider> = new InjectionToken<NavigationProvider>(
  'NAVIGATION_TOKEN',
  {
    factory: (): NavigationProvider => {
      const navigationService: NavigationService = inject(NavigationService);

      return {
        init() {
          navigationService.init();
        },
        back() {
          navigationService.back();
        },
        replace(url: string) {
          return navigationService.replace(url);
        },
        replaceHistoryEntry(url: string) {
          navigationService.replaceHistoryEntry(url);
        },
        hasHistory: navigationService.hasHistory,
        previousPage() {
          return navigationService.previousPage();
        }
      };
    }
  }
);

export interface NavigationProvider {
  init(): void;
  back(): void;
  replace(url: string): Promise<boolean>;
  replaceHistoryEntry(url: string): void;
  hasHistory: boolean;
  previousPage(): string;
}
